import { useQuery } from "react-query";
import axios from "axios";
import { getCommonUrl } from "../../../utils2024/utils";
import { getAdminHeader, getHeader } from "../../../utility/utility";

const doAction = async (path) => {
  const url = getCommonUrl(path);
  try {
    const res = await axios.get(url, getAdminHeader());
    return res.data;
  } catch (error) {
    throw error.response.data;
  }
};

const useAdminCommonGet = (path) => {
  return useQuery(["com-init-get", path], () => doAction(path), {
    staleTime: 1 * 60 * 1000, // Data will be considered stale after 5 minutes
    retry: 2, // If the query fails, it will retry up to 3 times
  });
};

export default useAdminCommonGet;
